import React from 'react'
import { Member } from 'memberships/schema'
import InfoRow, { InfoRowContainer } from 'uiComponents/infoRow'
import Section from '../../common/section/section'
import './member.scss'
import { formatISOString } from 'utils/dates'
import { DateFormats } from 'utils/dates'
import placeholderPhoto from 'images/member-photo-placeholder.png'
import PermissionRequired from 'admin/permissionRequired'

const calculateAge = (dateOfBirth: string) => {
    const birthDate = new Date(dateOfBirth)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}

interface MemberSectionProps {
    member?: Member
    isLoading?: boolean
    accountSlug: string
    openUpdateModal: () => void
}

const MemberSection = ({ member, openUpdateModal, isLoading, accountSlug }: MemberSectionProps) => {
    let birthDateText = '-'
    if (member?.dateOfBirth) {
        const formattedDateOfBirth = formatISOString(member.dateOfBirth, DateFormats.EXTRA_LONG_DATE)
        const age = calculateAge(member.dateOfBirth)
        const ageText = `${age} year${age === 1 ? '' : 's'} old`
        birthDateText = `${formattedDateOfBirth} (${ageText})`
    }

    return (
        <Section
            className="member"
            title={
                <>
                    <h5 className="section-title">Member</h5>
                    <PermissionRequired name="edit_orders" accountSlug={accountSlug}>
                        <span className="update-info" onClick={openUpdateModal}>
                            Update information
                        </span>
                    </PermissionRequired>
                </>
            }
        >
            <a
                className="member-photo"
                href={member?.photo}
                target="_blank"
                rel="noreferrer"
                style={{ backgroundImage: `url(${placeholderPhoto})` }}
            >
                {member?.photo && <img src={member?.photo} alt="Member" />}
            </a>
            <InfoRowContainer loading={isLoading}>
                <InfoRow label="First name" className="first-name" value={member?.firstName} />
                <InfoRow label="Last name" className="last-name" value={member?.lastName} />
                <InfoRow label="Date of birth" className="date-of-birth" value={birthDateText} />
                <InfoRow label="Phone number" className="phone-number" value={member?.phoneNumber} />
                <InfoRow label="Street address" className="street-address" value={member?.streetName} />
                <InfoRow label="Post code" className="post-code" value={member?.zipCode} />
                <InfoRow label="City" className="city" value={member?.city} />
                <InfoRow label="Country" className="country" value={member?.country} />
            </InfoRowContainer>
        </Section>
    )
}

export default MemberSection
